import type { TableSharedView } from '../table/TableSharedView';
import type { NullableKeys } from '../types/NullableKeys';
import type { FilterPreset } from './FilterPreset';

// GET /tables/url/:id
export type TablesUrlGetResponseBody = NullableKeys<
  TableSharedView,
  | 'attributeFilters'
  | 'autoSizedColumns'
  | 'columnVisibility'
  | 'columnWidth'
  | 'orderedColumns'
  | 'selectedFilter'
  | 'sort'
> & {
  createdAt: number;
  id: string;
  selectedFilterPreset?: FilterPreset;
};

// POST /tables/url
export type TablesUrlPostRequestBody = TableSharedView;
export type TablesUrlPostResponseBody = TableSharedView & {
  createdAt: number;
  openedAt: number;
  id: string;
};
